<div class="calendars-container">
  
  <div class="selector-header" *ngIf="isLoggedIn">
    <mat-form-field appearance="outline" class="account-selector">
      <mat-label>Linked accounts</mat-label>
      <mat-select [(ngModel)]="calendarIntegration" name="calendarIntegration" required 
                  [compareWith]="functions.objectComparisonFunction" 
                  (selectionChange)="changeCalendarIntegration(calendarIntegration)">
        <mat-option *ngFor="let acc of calendarIntegrations" [value]="acc">
          {{acc.description}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="table-wrapper">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z1">

      <ng-container matColumnDef="Summary">
        <th mat-header-cell *matHeaderCellDef> Summary </th>
        <td mat-cell *matCellDef="let element"> {{element.summary}} </td>
      </ng-container>
    
      <ng-container matColumnDef="Show in Yournotes">
        <th mat-header-cell *matHeaderCellDef> Show in Yournotes </th>
        <td mat-cell *matCellDef="let element" class="center-cell"> 
          <span class="status-icon" [class.active]="element.showInYournotes">
            {{element.showInYournotes ? '✓' : '✕'}}
          </span>
        </td>
      </ng-container>
    
      <ng-container matColumnDef="Sync Remarkable">
        <th mat-header-cell *matHeaderCellDef> Sync reMarkable </th>
        <td mat-cell *matCellDef="let element" class="center-cell"> 
          <span class="status-icon" [class.active]="element.syncRemarkable">
            {{element.syncRemarkable ? '✓' : '✕'}}
          </span>
        </td>
      </ng-container>
    
      <ng-container matColumnDef="Foldername Remarkable">
        <th mat-header-cell *matHeaderCellDef> Foldername reMarkable </th>
        <td mat-cell *matCellDef="let element"> {{element.foldernameRemarkable}} </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
          (click)="openCalendarModal(row)" 
          class="clickable-row"></tr>
    </table>
  </div>

  <!--mat-paginator *ngIf="calendarIntegration?.calendars?.length > 10" 
                 [pageSizeOptions]="[25, 50, 100]" 
                 class="sticky-paginator">
  </mat-paginator-->

</div>